"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/OrgSurvey/ProductInterestForm.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _components = require('web/screens/Signup/components');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _AuthFrame = require('web/components/AuthFrame');
var _productInterestOptions = require('./productInterestOptions');










const ProductInterestForm = ({ onBack, onSubmit, value, onChange }) => {
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)

  const isSelected = (key) => value.includes(key)

  // Multi-select toggle: clicking a card adds it, clicking a selected card
  // removes it. At least one must remain selected to enable Next.
  const toggle = (key) => {
    onChange(isSelected(key) ? value.filter(k => k !== key) : [...value, key])
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (!value.length) return
    setIsLoading(true)
    // Reset on every settled path: on error, and on the section's guard/no-op
    // returns. A successful submit navigates away and unmounts this form.
    Promise.resolve(onSubmit(value)).finally(() => setIsLoading(false))
  }

  // Enter on a card toggles it rather than submitting the form; Space works
  // as on any checkbox.
  const onCardKeyDown = (e, key) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      toggle(key)
    }
  }

  return (
    _react2.default.createElement('form', { onSubmit: handleSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
      , _react2.default.createElement(_components.SignupStepHeader, {
        title: "What do you want to use BloomText for?"       ,
        subtitle: "Pick everything that applies — we'll set you up with the right features."            , __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
      )
      , _react2.default.createElement('fieldset', { className: "signup--interest", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
        , _react2.default.createElement('legend', { className: "auth-sr-only", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, "What do you want to use BloomText for?"       )
        ,  _productInterestOptions.PRODUCT_INTEREST_OPTIONS.map(o => (
          _react2.default.createElement('label', {
            key: o.key,
            className: _classBuilder2.default.call(void 0, 
              "signup--interest-card",
              isSelected(o.key) && "signup--interest-card--on",
            ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}

            , _react2.default.createElement('input', {
              type: "checkbox",
              className: "signup--interest-card--input",
              checked: isSelected(o.key),
              onChange: () => toggle(o.key),
              onKeyDown: e => onCardKeyDown(e, o.key),
              'aria-labelledby': `interest-${o.key}-name`,
              'aria-describedby': `interest-${o.key}-desc`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
            )
            , _react2.default.createElement('span', { className: "signup--interest-card--box", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
              , _react2.default.createElement(_AuthFrame.CheckIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}} )
            )
            , _react2.default.createElement('span', { className: "signup--interest-card--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
              , _react2.default.createElement('span', { id: `interest-${o.key}-name`, className: "signup--interest-card--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}},  o.name )
              , _react2.default.createElement('span', { id: `interest-${o.key}-desc`, className: "signup--interest-card--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}},  o.desc )
            )
            , _react2.default.createElement('img', { src: o.iconSrc, className: "signup--interest-card--icon", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}} )
          )
        ))
      )
      , _react2.default.createElement(_components.SignupStepControls, {
        onBack: onBack,
        isNextDisabled: !value.length,
        isNextLoading: isLoading, __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
      )
    )
  )
}

exports. default = ProductInterestForm
